import {
  LOAD_TAX_RATES,
  TAX_RATES_LOADED,
  SAVE_TAX_RATE,
  TAX_RATE_SAVED,
  TAX_RATE_DELETED,
  RESET_TAX_RATES,
  RESET_SEARCH_TAX_RATES,
  SYNC_FAILED,
  LOAD_TAX_RATE,
  TAX_RATE_LOADED,
  LOAD_TAX_RATES_TYPES,
  SYNC_FAILED_TAX_RATES_TYPES,
  TAX_RATES_TYPES_LOADED,
} from './actionTypes';
import { ITaxRate } from './types';

export const initialState = {
  error: null,
  loaded: false,
  taxRates: [],
  taxRate: null,
  taxRateSaved: false,
  taxRateLoaded: false,
  taxRateSyncing: false,
  syncing: false,
  taxRatesTypes: [],
  errorTaxRatesTypes: null,
  loadedTaxRatesTypes: false,
  syncingTaxRatesTypes: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_TAX_RATES:
      return { ...state, error: null, syncing: true };
    case TAX_RATES_LOADED:
      return {
        ...state,
        error: null,
        taxRates: action.payload,
        syncing: false,
        loaded: true,
      };
    case TAX_RATE_LOADED:
      return {
        ...state,
        error: null,
        taxRate: action.payload,
        taxRateSyncing: false,
        taxRateLoaded: true,
      };
    case LOAD_TAX_RATE:
      return {
        ...state,
        error: null,
        taxRateSyncing: true,
        taxRateLoaded: false,
      };
    case SAVE_TAX_RATE:
      return {
        ...state,
        error: null,
        taxRateSaved: false,
        taxRateSyncing: true,
      };
    case TAX_RATE_SAVED:
      return {
        ...state,
        taxRateSaved: true,
        taxRateSyncing: false,
      };
    case TAX_RATE_DELETED:
      const newTaxRates = state.taxRates.filter((item: ITaxRate) => {
        return item.rateId !== action.payload;
      });

      return { ...state, taxRates: newTaxRates };
    case RESET_TAX_RATES:
      return initialState;
    case RESET_SEARCH_TAX_RATES:
      return { ...state, searchTaxRatesLoaded: false, searchTaxRates: [] };
    case SYNC_FAILED:
      return { ...state, syncing: false, taxRateSyncing: false, error: action.payload };
    case LOAD_TAX_RATES_TYPES:
      return { ...state, errorTaxRatesTypes: null, syncingTaxRatesTypes: true };
    case TAX_RATES_TYPES_LOADED:
      return {
        ...state,
        errorTaxRatesTypes: null,
        taxRatesTypes: action.payload,
        syncingTaxRatesTypes: false,
        loadedTaxRatesTypes: true,
      };
    case SYNC_FAILED_TAX_RATES_TYPES:
      return { ...state, syncingTaxRatesTypes: false, errorTaxRatesTypes: action.payload };
    default:
      return state;
  }
};
